import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

@Component({
  selector: 'widget-input-color',
  template: `
    <div [formGroup]="form"
         [class.has-error]="form.controls[id]?.touched && !form.controls[id]?.valid"
         [class.has-feedback]="form.controls[id]?.touched && !form.controls[id]?.valid">
      <label class="control-label text-right {{labelClass}}" [for]="id">{{ txtLabel | translate }}</label>
      <div class="{{containerInputClass}}" style="display: flex; align-items: center; gap: 8px;">
        <input type="color"
               class="form-control"
               style="width: 42px; height: 36px; padding: 2px; cursor: pointer; flex-shrink: 0;"
               [value]="getColorValue()"
               (input)="onColorPickerChange($event.target.value)"
               (change)="onColorPickerChange($event.target.value)"
               [disabled]="readonly">
        <input type="text"
               [id]="id"
               class="form-control validate"
               maxlength="7"
               [placeholder]="placeholder"
               [(ngModel)]="model"
               formControlName="{{id}}"
               (input)="onTextInputChange($event.target.value)"
               (change)="onTextInputChange($event.target.value)"
               [readonly]="readonly">
      </div>
    </div>
  `
})
export class WidgetInputColorComponent implements OnInit {

  @Input() id: string = '';
  @Input() model: any = '';
  @Output() modelChange = new EventEmitter<string>();
  @Input() form: any;
  @Input() txtLabel: string = '';
  @Input() labelClass: string = 'col-sm-3';
  @Input() containerInputClass: string = 'col-sm-3';
  @Input() readonly: boolean = false;
  @Input() placeholder: string = '#000000';

  ngOnInit(): void {}

  getColorValue(): string {
    let val = this.model || (this.form && this.form.controls[this.id] ? this.form.controls[this.id].value : '');
    if (val && typeof val === 'string' && val.startsWith('#') && (val.length === 7 || val.length === 4)) {
      return val;
    }
    return this.placeholder && this.placeholder.startsWith('#') ? this.placeholder : '#000000';
  }

  onColorPickerChange(val: string) {
    this.model = val;
    this.modelChange.emit(val);
    if (this.form && this.form.controls[this.id]) {
      this.form.controls[this.id].setValue(val, { emitEvent: true });
    }
  }

  onTextInputChange(val: string) {
    this.model = val;
    this.modelChange.emit(val);
    if (this.form && this.form.controls[this.id]) {
      this.form.controls[this.id].setValue(val, { emitEvent: true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-input-color.component.ts